export enum DisclosureValidationIdType {
  Ingredient = 'Ingredient',
  Purpose = 'Purpose',
  WaterSource = 'WaterSource',
}
